/**
 * @fileoverview Hook for checking feature flag states from the server
 *
 * @example
 * // Usage:
 * import { useFeatureFlag } from './useFeatureFlag'
 *
 * function Component() {
 *   // Check if a boolean feature flag is enabled
 *   const isFeatureEnabled = useFeatureFlag<boolean>('my-feature')
 *
 *   // Get a string value from a feature flag
 *   const variant = useFeatureFlag<string>('experiment-variant')
 *
 *   if (!isFeatureEnabled) {
 *     return null
 *   }
 *
 *   return <div>Feature is enabled!</div>
 * }
 */


import axios from 'axios'
import { useMemo, useState } from 'react'
import config from '../config'

/**
 * @function useFeatureFlag
 * @description Hook for checking feature flag states from the server
 * @param {string} name - The name of the feature flag
 * @returns {T} The state of the feature flag
 */
export function useFeatureFlag<T>(name: string) {
    const [state, setState] = useState<T>(undefined)

    useMemo(() => {
        if (!name) {
            return
        }

        axios.get(config.featureFlags.url + name).then(({ data }) => setState(data))
    }, [name])

    return state
}
